import { mapActions } from "vuex";
import { FETCH_PLACES } from "../../store/destinies/action-types";

export default {
  props: {
    background: {
      type: String,
      required: true,
      default: () => ""
    },
    title: {
      type: String,
      default: function() {
        return this.$t('home.main_title');
      }
    }
  },
  data: () => ({
    tab: null,
    items: [
      {
        tab: "Ida y vuelta el mismo día",
        disabled: false,
        icon: "ODAY",
        content: "HOLA1"
      },
      {
        tab: "Más de un día",
        disabled: true,
        icon: "MDAYS",
        content: "HOLA2"
      }
    ],
    text:
      "magna aliqua. Ut enim ad veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    personsOptions: ["1 persona", "2 personas", "3 personas"],
    daysOfWeek: ["dom", "lun", "mar", "mie", "jue", "vie", "sab"],
    form: {
      valid: false,
      from: {
        value: null,
        placeholder: "Seleccione su partida"
      },
      to: {
        value: null,
        placeholder: "Seleccione su destino"
      },
      persons: {
        value: "1 persona"
      },
      date: {
        showPicker: false,
        placeholder: "DD/MM/AAAA",
        value: null
      }
    },
    activeTab: 0,
    activeButton: 0
  }),
  created() {
    this.fetchPlaces().catch(() => {
      this.$toastr.e(
        "Ha ocurrido un error durante la búsqueda. Inténtalo nuevamente."
      );
    });
  },
  methods: {
    ...mapActions({
      fetchPlaces: FETCH_PLACES
    }),
    showDatePicker() {
      this.form.date.showPicker = !this.form.date.showPicker;
    },
    handleTabChange(event) {
      this.activeTab = event;
    },
    getDay(date) {
      let i = new Date(date).getDay();
      return this.daysOfWeek[i];
    },
    handleSearchTypeButton(event) {
      this.activeButton =
        event.currentTarget.getAttribute("id") === "when" ? 0 : 1;
    },
    search() {}
  }
};
